export enum StateKey {
  HasBalance = 'hasBalance',
  IsNativeApp = 'isNativeApp',
  Nonce = 'nonce',
}
